/**
 * Per-visitor urgency countdown for the cart drawer promo strip.
 *
 * The deadline is stored in localStorage on first view so it survives navigation
 * and drawer re-renders instead of restarting on every paint. When it runs out
 * the whole strip is removed.
 *
 * The drawer replaces its own markup on every cart update, so this binds by
 * walking the DOM on demand rather than relying on a single connected callback.
 */
(function () {
  var STORAGE_KEY = 'wtp:cart-promo-deadline';
  var SELECTOR = '.cart-drawer__promo[data-promo-timer-minutes]';

  function readDeadline(minutes) {
    var now = Date.now();
    var stored = null;

    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      // Private mode / blocked storage: fall back to a per-page deadline.
      return now + minutes * 60000;
    }

    var parsed = stored ? parseInt(stored, 10) : NaN;

    // A stored deadline further out than the configured window means the setting
    // was lowered since; re-anchor so the merchant's change takes effect.
    if (!isNaN(parsed) && parsed > now && parsed <= now + minutes * 60000) {
      return parsed;
    }

    var deadline = now + minutes * 60000;
    try {
      window.localStorage.setItem(STORAGE_KEY, String(deadline));
    } catch (e) {
      /* not fatal */
    }
    return deadline;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function render(strip, remaining) {
    var totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    var parts = {
      hours: Math.floor(totalSeconds / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    Object.keys(parts).forEach(function (unit) {
      var node = strip.querySelector('[data-promo-' + unit + ']');
      if (!node) return;
      var next = pad(parts[unit]);
      if (node.textContent !== next) node.textContent = next;
    });
  }

  function start(strip) {
    if (strip.dataset.promoTimerBound === 'true') return;
    strip.dataset.promoTimerBound = 'true';

    var minutes = parseInt(strip.dataset.promoTimerMinutes, 10);
    if (!minutes || minutes < 0) return;

    var deadline = readDeadline(minutes);

    var tick = function () {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        render(strip, 0);
        window.clearInterval(strip._promoTimer);
        strip.remove();
        return;
      }
      render(strip, remaining);
    };

    tick();
    strip._promoTimer = window.setInterval(tick, 1000);
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
    });
  } else {
    bindAll(document);
  }

  // Re-bind after the drawer swaps its contents on add/update.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) start(node);
        else bindAll(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
